import React, { useEffect } from 'react';
import { Box, CircularProgress } from '@material-ui/core';
import { useHistory } from 'react-router-dom';
import { toast } from 'react-toastify';
import { useTranslation } from 'react-i18next';
import { MESSAGE_PAYMENT_ERROR } from 'utils/constants';
import { getParam } from 'submodules/OrderCore';
import { ETypePayment, TYPE } from 'types/globalType';
import { shallow } from 'zustand/shallow';
import { useStore } from 'features/home/store/homeSlice';
import { useGroupStore } from 'features/group/store/groupSlice';
import { checkGroup, handleRouter } from 'utils/restaurantFeatures';

const CheckErrorPayment = () => {
  const history = useHistory();
  const { homeState } = useStore(
    (state) => ({
      homeState: state.homeState,
    }),
    shallow,
  );

  const { groupState } = useGroupStore(
    (state) => ({
      groupState: state.groupState,
    }),
    shallow,
  );

  const state = checkGroup() ? groupState : homeState;
  const { t } = useTranslation();
  const { search } = window.location;

  const onRouter = (customUrl: string) => {
    handleRouter({
      history,
      state,
      customUrl,
      fileName: 'CheckErrorPayment',
    });
  };
  useEffect(() => {
    const type = getParam(search, TYPE);
    if (type === ETypePayment.ERROR) {
      toast.error(t(MESSAGE_PAYMENT_ERROR));
    }
    window.parent.postMessage(type, window.location.origin);
    const info = state.info;
    if (info?.groupId) {
      onRouter(`/${info.menuId}/add-information`);
    } else {
      onRouter('/add-information');
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [history, search, state, state.info]);

  return (
    <Box sx={{ width: '100%' }} display="flex" alignItems="center" justifyContent="center">
      <CircularProgress />
    </Box>
  );
};

export default CheckErrorPayment;
